import React from 'react';
import {Box} from "@mui/material";
import Header from './Header';

interface OwnProps {
  children: React.ReactNode;
  bgColor?: string;
  padding?: number;
}

const PageWithHeader = (props: OwnProps) => {
  const {children, bgColor, padding=0} = props;
  return (
    <Box sx={{minHeight: '100vh', backgroundColor: bgColor || '#f5f5f5', margin: 0, padding: 0}}>
      <Header/>
      <Box sx={{padding: padding, pb: 4}}>
        {children}
      </Box>
    </Box>
  );
}

export default PageWithHeader;
